import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// api
import { getInfantilProductsByList } from 'api/lists';
// components
import ItemListChildren from 'components/itemListChildren/item';
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import NoResults from 'components/userzone/NoResults';
import SectionLoader from 'components/loader/SectionLoader';
import PaginationLoader from 'components/loader/PaginationLoader';
import Pagination from 'components/userzone/Pagination';
//images
import NoResultIcon from 'assets/img/no_item_found.jpg';
// styles
import './childrenBooks.scss';

const PAGE_SIZE = 18;

const ChildrenBooks = () => {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const hasLoadedOnce = useRef(false);

  const { t } = useTranslation(['childrenBooks', 'header', 'home', 'backoffice']);

  const title = t('infantil', { ns: 'backoffice' });

  useEffect(() => {
    const load = async () => {
      if (!hasLoadedOnce.current) {
        setIsInitialLoading(true);
      } else {
        setIsPageLoading(true);
      }
      try {
        const { data, status } = await getInfantilProductsByList({
          page,
          page_size: PAGE_SIZE,
          fields:
            'id,image,titulo,price,discount,fecha_public,type,languages,authors,has_stock,is_novelty,has_used,has_newbalance',
        });
        if (status === 200) {
          const results = data?.results || (Array.isArray(data) ? data : []);
          setItems(results);
          const tp =
            data?.total_pages != null
              ? data.total_pages
              : data?.count != null
                ? Math.ceil(data.count / PAGE_SIZE)
                : 1;
          setTotalPages(Math.max(1, tp || 1));
        } else {
          console.error('products_infantil status no esperado:', status, data);
          setItems([]);
          setTotalPages(1);
        }
      } catch (error) {
        console.error('Error cargando products_infantil:', error);
        setItems([]);
        setTotalPages(1);
      } finally {
        hasLoadedOnce.current = true;
        setIsInitialLoading(false);
        setIsPageLoading(false);
      }
    };
    load();
  }, [page]);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className="container-fluid px-2 mainDiv">
      <Head title={title} />
      <Row className="px-2 mx-1">
        <Col md={12} className="pl-1">
          <TitleWithLine text={t('infantil', { ns: 'backoffice' })} />
        </Col>
      </Row>
      <Container fluid className="px-2 mx-0">
        {isInitialLoading ? (
          <SectionLoader />
        ) : (
          <>
            {isPageLoading ? (
              <div className="children-books-page-loader">
                <PaginationLoader visibility={true} />
              </div>
            ) : items.length > 0 ? (
              <div className="children-books-results-wrapper">
                <Row className="itemsRow justify-content-center mx-0">
                  {items.map((item, i) => (
                    <Col xs={12} sm={6} md={3} lg={2} key={item?.id ?? i} className="px-2 mb-4 mt-4">
                      <ItemListChildren data={item} />
                    </Col>
                  ))}
                </Row>
                {totalPages > 1 && (
                  <Row className="mb-4">
                    <Col md={12} className="d-flex justify-content-center">
                      <Pagination changePage={changePage} page={page} totalPages={totalPages} />
                    </Col>
                  </Row>
                )}
              </div>
            ) : (
              <NoResults
                text={t('noResults', { ns: 'backoffice' })}
                icon={NoResultIcon}
                className="noFavorites"
                showBackToHome={true}
              />
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default ChildrenBooks;
